export default __webpack_public_path__ + "static/media/LOGO-OCSB.3ed2ff7b.gif";